import {AxiosError} from 'axios'
import {useQuery} from 'react-query'

import {trackEvent} from '../../../analytics'
import {queries} from '../../queries'
import {useErrorHandling} from '../useErrorHandling'

export const useGetSlotStatuses = () => {
  const {handleApiUnavailable, handleNetworkError, handleUnauthorized, handleNoPermissions} =
    useErrorHandling()
  return useQuery('slotStatuses', queries.slotStatuses, {
    onError: (err: AxiosError) => {
      const isNetworkError = err.message === 'Network Error'
      const status = err.response?.status

      const trackEventData = {
        type: 'getStatuses'
      }

      const frontendErrorTrackEvent = void trackEvent(
        'hubOrderIntakeSlotFrontendError',
        trackEventData
      )

      if (isNetworkError) handleNetworkError('plants')
      if (status === 401) handleUnauthorized()
      if (status === 403) handleNoPermissions(frontendErrorTrackEvent)
      if (status === 503) handleApiUnavailable()
    }
  })
}
